import styled from 'styled-components';
import React from 'react';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import BusinessListUnitItem from '../BusinessListUnitItem/BusinessListUnitItem';
import BusinessGroupListItem from '../BusinessGroupListItem/BusinessGroupListItem';
import SearchBusinessGroupWithChildItem from './SearchBusinessGroupWithChildItem';

const StyledSearchBusinessWithBusinessGroupDisplayUnitItem = styled.div``;

interface SearchBusinessWithBusinessGroupDisplayUnitItemProps {
    businessDisplayUnit: BusinessDisplayUnit;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}
const SearchBusinessWithBusinessGroupDisplayUnitItem = ({
    businessDisplayUnit,
    onSelect,
}: SearchBusinessWithBusinessGroupDisplayUnitItemProps) => {
    const renderChildUI = () => {
        if (businessDisplayUnit.isBusiness) {
            return (
                <BusinessListUnitItem
                    businessDisplayUnit={businessDisplayUnit}
                    onSelect={onSelect}
                />
            );
        }
        if (businessDisplayUnit.childBusinessDisplayUnit) {
            return (
                <SearchBusinessGroupWithChildItem
                    businessGroup={businessDisplayUnit}
                    onSelect={onSelect}
                />
            );
        }
        return <BusinessGroupListItem businessGroup={businessDisplayUnit} onSelect={onSelect} />;
    };
    return (
        <StyledSearchBusinessWithBusinessGroupDisplayUnitItem>
            {renderChildUI()}
        </StyledSearchBusinessWithBusinessGroupDisplayUnitItem>
    );
};

export default SearchBusinessWithBusinessGroupDisplayUnitItem;
